/**
 * API Configuration
 * Centralized configuration for API base URL
 *
 * Development:  reads VITE_API_BASE from .env  (e.g. http://localhost/FirmaFlow)
 * Production:   reads VITE_API_BASE from .env.production
 *               If not set (or empty), falls back to relative URLs so the
 *               built dist folder works on ANY domain without rebuilding.
 */

// Honour the configured backend in every mode. During local development this
// points the React app directly at the PHP project served by XAMPP.
const _configuredBase = import.meta.env.VITE_API_BASE?.trim() ?? '';
export const API_BASE_URL = _configuredBase.replace(/\/+$/, '');

// Superadmin API base (for superadmin panel pages)
export const SUPERADMIN_API_BASE = `${API_BASE_URL}/superadmin/api`;

// Regular API base
export const API_URL = `${API_BASE_URL}/api`;

// Helper function to build API endpoints
export const buildApiUrl = (path) => {
  // Remove leading slash if present to avoid double slashes
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;
  return API_BASE_URL ? `${API_BASE_URL}/${cleanPath}` : `/${cleanPath}`;
};

export const buildStoredImageUrl = (path) => {
  if (!path) return null;
  if (
    path.startsWith("http://") ||
    path.startsWith("https://") ||
    path.startsWith("data:") ||
    path.startsWith("blob:")
  ) {
    return path;
  }

  const cleanPath = path.startsWith("/") ? path.slice(1) : path;
  if (cleanPath.startsWith("uploads/")) {
    return buildApiUrl(
      `api/serve_image.php?path=${encodeURIComponent(cleanPath)}`
    );
  }

  return buildApiUrl(cleanPath);
};

export default API_BASE_URL;
